module.exports = require('./dist/jstz.js');



//////////////////
// WEBPACK FOOTER
// ./~/jstz/index.js
// module id = 3740
// module chunks = 0